import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { profileMenuLabelId } from '../../util/profileTabs';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

const PROFILE_PAGES = [
  'YourProfilePage',
  'YourProfilePageTab',
  'ProfileSettingsPage',
  'ManageListingsPage',
  'EditListingPage',
];

/**
 * A component that renders a navigation bar for a user-specific pages.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} props.currentPage - The current page (e.g. 'YourProfilePage')
 * @returns {JSX.Element} User navigation component
 */
const UserNav = props => {
  const { className, rootClassName, currentPage } = props;
  const intl = useIntl();
  const currentUser = useSelector(state => state.user?.currentUser);
  const currentUserHasListings = useSelector(state => state.user?.currentUserHasListings);
  const currentUserOwnListing = useSelector(state => state.user?.currentUserOwnListing);
  const classes = classNames(rootClassName || css.root, className);

  const tabs = [
    {
      text: (
        <FormattedMessage
          id={profileMenuLabelId({
            currentUser,
            currentUserHasListings,
            currentUserOwnListing,
          })}
        />
      ),
      selected: PROFILE_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'YourProfilePage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'AccountSettingsPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal
      className={classes}
      tabRootClassName={css.tab}
      tabs={tabs}
      skin="dark"
      ariaLabel={intl.formatMessage({ id: 'UserNav.screenreader.userNav' })}
    />
  );
};

export default UserNav;
